export const useSxStyles = () => {
  const backgroundColor = '#fafafa';

  return {
    loading: {
      backgroundColor,
    },
    preRoutedContent: {
      backgroundColor,
      width: '100%',
      height: '100%',
    },
  };
};
